module.exports = __webpack_public_path__ + "9e78676042b0656e2cc98398b0dc674a.jpg";